<style lang="scss" scoped>
.appraisal-title {
  color: #3a3a3a;
}
.appraisal-center {
  width: 90%;
  margin: 0 auto;
}
.fonts {
  font-size: 14px;
}
.topic-outer {
  width: 100%;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}
.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.fl1 {
  flex: 1;
  -webkit-flex: 1;
}
.glay {
  color: #8492a6;
  i {
    font-style: normal;
    color: #f56c6c;
  }
}
.pub-line {
  margin-top: 30px;
}
.pub-marr {
  margin-top: 20px;
}
.marr {
  margin-top: 30px;
}
.tag-marr {
  margin-right: 5px;
  cursor: pointer;
}
.subject {
  color: #8492a6;
  margin-left: 10px;
  i {
    font-style: normal;
    color: #f56c6c;
  }
}
.activeBg {
  background: #b3d8ff;
  color: #fff;
}
.active-bg1 {
  background: #fbc4c4;
  color: #fff;
}
.active_display{
  height: 0;
  opacity: 0;
  overflow: hidden;
}
</style>
<template>
  <div>
    <el-page-header @back="goBack" content=" 维护测评题目"> </el-page-header>
    <div class="topic-outer">
      <div class="appraisal-center fonts">
        <div class="pub-line">
          <span>分类：</span>
          <span class="glay"
            >{{ detalisObj.categoryName1 }}-{{ detalisObj.categoryName }}</span
          >
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>名称：</span>
            <span class="glay">{{ detalisObj.name }}</span>
          </div>
          <div class="fl1">
            <span> 标识：</span>
            <span class="glay">{{ detalisObj.examId }}</span>
          </div>
        </div>

        <div class="flex-box pub-line">
          <div class="fl1">
            <span>解析：</span>
            <span class="glay">{{ detalisObj.schemeName }}</span>
          </div>
          <div class="fl1">
            <span> 题目：</span>
            <span class="glay">
              共 <i>{{ detalisObj.questions }} </i>题，<i
                >{{ detalisObj.maxScore }} </i
              >分
            </span>
          </div>
        </div>
        <div style="margin-top: 30px">
          <el-button type="primary" plain @click="handelResultSet"
            >结果设置</el-button
          >
          <el-button type="danger" plain @click="delQuestionBank"
                     v-if="numType"
            >删除所有题目</el-button
          >
          <el-button type="danger" plain @click="operationShowTime"
                     v-else
          >删除所有题目</el-button
          >
        </div>
      </div>
    </div>

    <div class="topic-outer">
      <div class="appraisal-center fonts marr">
        <div>
          <span>维度：</span>
          <span>
            <template v-if="numType">
              <el-tag
                  :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                  :closable="item.code == 'ZHWD_7' ? false : true"
                  v-for="(item, index) in getWDData"
                  :key="item.examDimensionId"
                  @close="handleCloseWd(item.code)"
                  @click="activeEvent(index, item.code, item.name)"
                  effect="plain"
              >{{ item.name }}</el-tag
              >
            </template>
            <template v-else>
              <el-tag
                  :class="{ 'tag-marr': true, activeBg: tagIndex == index }"
                  :closable="item.code == 'ZHWD_7' ? false : true"
                  v-for="(item, index) in getWDData"
                  :key="item.examDimensionId"
                  @close="operationShowTime"
                  @click="activeEvent(index, item.code, item.name)"
                  effect="plain"
              >{{ item.name }}</el-tag
              >
            </template>
            <el-tag class="tag-marr" effect="plain" @click="handleAdd('wd')"
              ><i class="el-icon-plus"></i
            ></el-tag>
             <el-tag class="tag-marr" effect="plain" @click="handleDimensionEdit()"
             ><i class="el-icon-edit"></i
             ></el-tag>
          </span>
        </div>

        <div style="margin-top: 20px">
          <span>题目：</span>
          <el-button type="success" size="small" @click="handleAdd('topic')"
            >添加 <i class="el-icon-plus"></i
          ></el-button>
          <span class="subject"
            >共 <i>{{ tagIndex==0 ?  detalisObj.questions : emptyShow(getWDData[tagIndex]).questions }}</i> 题，<i>{{
             tagIndex==0 ?  detalisObj.maxScore :  emptyShow(getWDData[tagIndex]).maxScore
            }}</i
            >分
          </span>
        </div>

        <div style="margin-top: 20px">
          <div class="public-table-data">
            <el-table
              ref="multipleTable"
              size="medium"
              :data="tableData"
              border
              style="width: 100%"
              row-key="menuId"
              v-loading="loading"
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="examDimensionVo"
                label="维度"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  {{ emptyShow(scope.row.examDimensionVo).name }}
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="题目"
                min-width="300"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="viewName"
                label="布局"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="answers"
                label="答案"
                width="80"
                align="center"
              >
              </el-table-column>

              <el-table-column
                prop="payPrice"
                label="分数"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.minScore }}~{{ scope.row.maxScore }}
                </template>
              </el-table-column>

              <el-table-column
                prop="seq"
                label="排序"
                width="100"
                align="center"
              >
              </el-table-column>
              <el-table-column label="操作" align="center" fixed="right" min-width="300">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleAdd('edit', scope.row)"
                    type="success"
                    plain
                    >编辑</el-button
                  >
                  <el-button
                    size="mini"
                    @click="handleAdd('answer', scope.row)"
                    type="warning"
                    plain
                    >答案</el-button
                  >
                  <el-button
                    size="mini"
                    @click="handleDelete(scope.row)"
                    type="danger"
                    plain
                    v-if="numType"
                    >删除</el-button
                  >
                  <el-button
                      v-else
                      size="mini"
                      @click="operationShowTime"
                      type="danger"
                      plain
                  >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加维度/基准弹框 -->
    <el-dialog
      :title="'添加维度'"
      :visible.sync="dialogVisible"
      width="460px"
      :close-on-click-modal="false"
      class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="params"
          label-width="80px"
        >
          <el-form-item label="ICON">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                  v-for="(imgUrl, index) in srcList"
                  :key="index"
                  class="slideshow"
                  v-if="params.icon"
                >
                  <el-image
                    style="width: 75px; height: 75px; border-radius: 6px"
                    :src="imgUrl"
                    fit="cover"
                    @click="getPolicy"
                  />
                </span>
                <div
                  class="up-btn"
                  style="width: 75px; height: 75px; line-height: 80px"
                  @click="getPolicy"
                  v-if="!params.icon"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                type="file"
                ref="file"
                @change="getFile"
                accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>

          <el-form-item label="名称" prop="name">
            <el-input placeholder="请填写名称" v-model="params.name"></el-input>
          </el-form-item>

          <el-form-item prop="code" label="标识">
            <el-input placeholder="请填写标识" v-model="params.code"></el-input>
          </el-form-item>
          <el-form-item label="说明" prop="descr">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入说明"
              v-model="params.descr"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="seq" label="序号">
            <el-input placeholder="请填写序号" v-model="params.seq"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
          >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加 编辑 题目弹框 -->
    <el-dialog
      :title="clickType == 'edit' ? '编辑题目' : '添加题目'"
      :visible.sync="dialogVisibleTopic"
      width="460px"
      :close-on-click-modal="false"
      class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
          ref="ruleFormTopic"
          :rules="rulesTopic"
          :model="topicParams"
          label-width="80px"
        >
          <el-form-item label="维度">
            {{ resue.name }}
          </el-form-item>
          <el-form-item label="布局" prop="view">
            <el-select
              v-model="topicParams.view"
              clearable
              placeholder="请选择布局"
              style="width: 100%"
            >
              <el-option label="方式一(列表)" value="ve1"></el-option>
              <el-option label="方式二(四维)" value="ve2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="图片">
            <div class="diplay" style="margin-right: 10px">
              <div class="screenshot">
                <span
                  v-for="(imgUrl, index) in srcList"
                  :key="index"
                  class="slideshow"
                >
                  <el-image
                    style="width: 75px; height: 75px; border-radius: 6px"
                    :src="imgUrl"
                    fit="cover"
                    @click="getPolicy(index)"
                  />
                </span>
                <div
                  class="up-btn"
                  style="width: 75px; height: 75px; line-height: 80px"
                  @click="getPolicy"
                  v-if="isMoer"
                >
                  <i class="el-icon-plus"></i>
                </div>
              </div>
              <input
                type="file"
                ref="file"
                @change="getFile"
                accept="image/png,image/jpg"
              />
            </div>
          </el-form-item>

          <el-form-item prop="name" label="题目">
            <el-input
              placeholder="请填写题目"
              v-model="topicParams.name"
            ></el-input>
          </el-form-item>

          <el-form-item label="解析" prop="descr">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请填写解析"
              v-model="topicParams.descr"
            >
            </el-input>
          </el-form-item>

          <el-form-item prop="tx" label="排序">
            <el-input
                type="number"
                placeholder="请填写排序"
                v-model="topicParams.seq"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisibleTopic = false"
          >取 消</el-button
        >
        <el-button
          size="medium"
          type="primary"
          @click="handleEditTopic(clickType == 'topic' ? 'topic' : 'edit')"
          >提 交</el-button
        >
      </span>
    </el-dialog>
    <!-- 添加答案弹框 -->
    <el-dialog
      title="添加答案"
      :visible.sync="dialogVisibleAnswer"
      width="700px"
      :close-on-click-modal="false"
      class="public-dialog"
    >
      <div style="margin-bottom: 20px">
        <span>题目：</span>
        <span>{{ topicTitle }}</span>
      </div>
      <div style="margin-bottom: 20px">
        <span>布局：</span>
        <span>
          <el-radio v-model="answerParams.radio" label="sel1">单选</el-radio>
          <el-radio v-model="answerParams.radio" label="sel2" disabled
            >多选</el-radio
          >
        </span>
      </div>
      <div class="public-table-data">
        <el-table
          ref="multipleTable"
          size="mini"
          :data="answerTableData"
          border
          style="width: 100%"
          row-key="menuId"
          v-loading="loading"
        >
          <el-table-column type="index" label="序号" width="80" align="center">
          </el-table-column>
          <el-table-column prop="icon" label="图标" width="120" align="center">
            <template slot-scope="scope">
              <div class="diplay"  @click="aaa(scope.$index)">
                <div class="screenshot"  >
<!--                  {{answerTableData[0].icon}}-->
                  <span


                    class="slideshow"
                  >
                    <el-image
v-if="scope.row.icon"
                      style="width: 40px; height: 40px; border-radius: 6px"
                      :src="scope.row.icon"
                      fit="cover"
                      @click="getPolicyAnswer"
                    />
                  </span>
                  <div

                    class="up-btn"
                    style="width: 40px; height: 40px; line-height: 45px"
                    @click="getPolicyAnswer"
                    v-if="!scope.row.icon"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>

                <input

                  type="file"
                  ref="fileAnswer"
                  id="uploadFile"
                  @change="getFileAnswer()"
                  accept="image/png,image/jpg"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="答案" width="200" align="center">
            <template slot-scope="scope">
              <el-input
                type="text"
                v-model="scope.row.name"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="分值" width="80" align="center">
            <template slot-scope="scope">
              <el-input
                type="text"
                v-model="scope.row.score"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="seq" label="排序" width="80" align="center">
            <template slot-scope="scope">
              <el-input
                type="text"
                v-model="scope.row.seq"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleAnswerDelete(scope.row, scope.$index)"
                type="danger"
                plain
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisibleAnswer = false"
          >取 消</el-button
        >
        <el-button size="medium" type="success" @click="handleAddAnswer"
          >添加答案</el-button
        >
        <el-button size="medium" type="primary" @click="submitAnswer"
          >提 交</el-button
        >
      </span>
    </el-dialog>
    <operation-confirmation  @closeOperation="publicMethios" :operationVisible="operationVisible"></operation-confirmation>
  </div>
</template>
<script>
import { ossUpload } from "@utils/filters/upload";

import { isEmpty, emptyShow } from "@utils/tools/index";
import OperationConfirmation from "../../../components/OperationConfirmation";

export default {
  components: {
    OperationConfirmation
  },
  data() {
    return {
      newtabindex:0,
      tableData: [],
      emptyShow,
      isEmpty,
      loading: false,
      detalisObj: {},
      getWDData: [], //维度列表
      getJZData: [], //基准列表
      dialogVisible: false,
      dialogVisibleTopic: false,
      dialogVisibleAnswer: false,
      params: {},
      topicParams: {},
      answerParams: {},
      topicTitle: "",
      clickType: "",
      srcList: [],
      isMoer: true,
      srcListAnswer: [],
      acrtArr: [],
      isMoerAnswer: true,
      tagIndex: 0,
      tagJzIndex: 0,
      resue: {},
      rules: {
        name: [{ required: true, message: "请填写名称", trigger: "change" }],
        code: [{ required: true, message: "请填写标识", trigger: "change" }],
        // descr: [{ required: true, message: "请填写说明", trigger: "change" }],
        seq: [{ required: true, message: "请填写标识", trigger: "change" }],
      },
      rulesTopic: {
        view: [{ required: true, message: "请选择布局", trigger: "change" }],
        name: [{ required: true, message: "请填写题目", trigger: "change" }],
        // descr: [{ required: true, message: "请填写解析", trigger: "change" }],
      },
      answerTableData: [
        {
          icon: "",
          descr: "",
          score: "",
          seq: "",
          answerId: 0,
        },
      ],
      operationVisible:false,
      numType:false
    };
  },
   watch: {
    dialogVisibleTopic() {
      if (this.dialogVisibleTopic == false) {
        this.$refs["ruleFormTopic"].resetFields();
        this.topicParams = {};
        this.srcList=[]
        this.isMoer=true
      }
    },
  },
  created() {
    this.getAppraisalData();
    this.getWDList();
  },
  methods: {
    //清楚缓存数据，重启密码验证
    clearStore(){
      window.sessionStorage.removeItem('operationKey')
      this.numType = false
    },
    //关闭
    publicMethios(e){
      this.operationVisible = false
      if(e=='open'){
        this.numType = true
        setTimeout(()=>{
          window.sessionStorage.removeItem('operationKey')
          this.numType = false
        },1800000)
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e){
      this.operationVisible = true
    },
    handleDimensionEdit(){
      this.srcList = [];
      this.params = this.getWDData[this.tagIndex]
      this.srcList.push(this.getWDData[this.tagIndex].icon);
      this.dialogVisible = true
    },
    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;

      const { data: resData } = await this.$get(
        `exam/info/${this.$route.query.examId}`
      );
      this.loading = false;
      if (resData.result != 200) return;

      this.detalisObj = resData.data;
    },
    /**
     * 删除测评题库
     */
    delQuestionBank() {
      this.$confirm("此操作将永久删除该测评题库数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const { data: resData } = await this.$delete(
          `exam/question/list/${this.$route.query.examId}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;
        this.getAppraisalData();
        this.getTopicList(this.resue.code);
        this.getWDList();
        this.$message.success("删除成功!");
      });
      this.clearStore()
    },
    /**
     * 获取测评维度列表
     */
    async getWDList() {
      this.getWDData = [];
      this.loading = true;
      const { data: resData } = await this.$get(`exam/dimension/list`, {
        params: {
          examId: this.$route.query.examId,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;

      if (resData.data) this.getWDData = resData.data;


      /* tagIndex :激活的是哪个 维度  */
      if(this.getWDData.length!=0){
        this.resue = {
          code: this.getWDData[this.tagIndex].code,
          name: this.getWDData[this.tagIndex].name,
        };
        this.getTopicList(this.resue.code); //初始化表格
        // if(this.tagIndex==0){
        //   this.getTopicList(); //初始化表格
        // }else{
        //   this.getTopicList(this.resue.code); //初始化表格
        // }

      }else{
        this.tableData = [];  return
      }

    },

    /**
     * 获取题目列表
     */
    async getTopicList(examDimensionCode) {
      this.loading = true;
      let temp={ examId: this.$route.query.examId,}

      if(emptyShow(examDimensionCode)){
        temp.examDimensionCode=examDimensionCode
      }
      const { data: resData } = await this.$get(`exam/question/list`, {
        params:temp,
      });

      this.loading = false;
      if (resData.result != 200) return;
      if (emptyShow(resData.data)) {

        // let arr = resData.data
        // arr.forEach((item,idx)=>{
        // })
        this.tableData = resData.data;

      } else {
        this.tableData = [];
      }
    },

    /**
     * 添加维度or添加基准  编辑
     * wd：维度；jz：基准
     */
    async handleAdd(type, row) {
      this.clickType = type;
      if (type == "wd") {
        this.dialogVisible = true;
      }
      if (type == "topic") {
        // if (this.tagIndex !== 0) {
        //   this.dialogVisibleTopic = true;
        // } else {
        //   this.$message.warning("请选择维度（非综合）!");
        // }
        this.dialogVisibleTopic = true;
        this.topicParams={view:'ve1'}
      }
      if (type == "edit") {
        this.dialogVisibleTopic = true;
        const { data: resData } = await this.$get(
          `exam/question/info/${row.questionId}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;

         this.topicParams = resData.data;
        if(emptyShow(this.topicParams.icon)){
          this.srcList = [];
          this.isMoer = false;
          this.srcList.push(resData.data.icon);
        }

      }
      if (type == "answer") {
        this.dialogVisibleAnswer = true;
        this.answerParams.questionId = row.questionId;
        this.answerParams.radio = row.answerWay;

        this.topicTitle = row.name;
        this.getAnswerList(row.questionId);
      }
    },
    /**
     * 获取答案列表
     */
    async getAnswerList(questionId) {
      this.answerTableData=[]
      const { data: resData } = await this.$get(
        `exam/answer/list`,
        {
          params: {
            questionId,
          },
        },
        {
          headers: {
            isLoading: true,
          },
        }
      );
      if (resData.result != 200) return;
      if (resData.data) {
        this.answerTableData = resData.data;
      }
    },

    /**
     * 新增
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.examId = this.$route.query.examId;
          if (this.clickType == "wd") {
            const { data: resData } = await this.$post(
              "exam/dimension/info",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
            );
            if (resData.result != 200) return;
            this.dialogVisible = false;
            this.$message.success("添加成功!");
            this.getWDList();
            this.params = {};
          }else {
            const { data: resData } = await this.$post(
                "exam/dimension/info",
                this.params,
                {
                  headers: {
                    isLoading: true,
                  },
                }
            );
            if (resData.result != 200) return;
            this.dialogVisible = false;
            this.$message.success("编辑成功!");
            this.getWDList();
            this.params = {};
          }
        });
      });
    },
    /**
     * 新增题目
     */
    handleEditTopic(type) {
      this.$refs.ruleFormTopic.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.topicParams.examId = this.$route.query.examId;
          this.topicParams.examDimensionCode = this.resue.code;
          this.topicParams.answerWay = "sel1";
          if (type == "topic") {
            const { data: resData } = await this.$post(
              "exam/question/info",
              this.topicParams,
              {
                headers: {
                  isLoading: true,
                },
              }
            );
            if (resData.result != 200) return;
            // this.getTopicList();
            this.dialogVisibleTopic = false;
            this.$message.success("添加成功!");
            this.topicParams = {};
          } else if (this.clickType == "edit") {
            const { data: resData } = await this.$put(
              "exam/question/info",
              this.topicParams,
              {
                headers: {
                  isLoading: true,
                },
              }
            );
            if (resData.result != 200) return;
            this.dialogVisibleTopic = false;
            // this.getTopicList();
            this.dialogVisible = false;
            this.$message.success("修改成功!");
            this.topicParams = {};
          }
          this.getTopicList(this.resue.code); //刷新维度列表
          this.getWDList();
          this.getAppraisalData(); //刷新总题目
        });
      });
    },
    /**
     * 删除题目
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const { data: resData } = await this.$delete(
          `exam/question/info/${row.questionId}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;
        this.getTopicList(this.resue.code);
        this.getWDList();
        this.getAppraisalData();
        this.$message.success("删除成功!");
      });
      this.clearStore()
    },

    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile(tableIdex) {
      const that = this;

      const { data: resData } = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });

      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
        that.$refs.file.files[0],
        resData.data,
        "one", //'more','one'
        this.srcList
      );

      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.icon = this.srcList[0];
      this.topicParams.icon = this.srcList[0];

    },

    getPolicyAnswer() {

      this.$refs.fileAnswer.dispatchEvent(new MouseEvent("click"));
    },
    aaa(val) {
      this.newtabindex = val
    },
    async getFileAnswer(tableIdex) {
      const that = this;
      const { data: resData } = await this.$get("aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
        that.$refs.fileAnswer.files[0],
        resData.data,
        "one", //'more','one'
        this.srcListAnswer
      );
      this.isMoerAnswer = false;
      this.srcListAnswer = addRoutes;

      this.answerTableData[this.newtabindex].icon = this.srcListAnswer[0];
    },

    goBack() {
      this.$router.go(-1);
    },
    /**
     * 删除维度
     */
    handleCloseWd(code) {
      this.$confirm("此操作将永久删除维度, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const { data: resData } = await this.$delete(
          `exam/dimension/info/${this.$route.query.examId}/${code}`,
          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;
        this.getWDList();
        this.$message.success("删除成功!");
      });
      this.clearStore()
    },

    /**
     * 点击维度
     */
    activeEvent(index, code, name) {
      this.tagIndex = index;
      this.tagJzIndex = 0;
      this.resue = {
        name,
        code,
      };
      this.getTopicList(this.resue.code); //初始化表格
      // if(this.tagIndex==0){
      //   this.getTopicList(); //初始化表格
      // }else{
      //   this.getTopicList(this.resue.code); //初始化表格
      // }
      // this.getWDList()
    },

    // 添加字段按钮
    handleAddAnswer() {
      // 向表格数组中数据添加一行
      this.answerTableData.push({
        icon: "",
        descr: "",
        score: "",
        seq: "",
        answerId: this.answerTableData.length,
      });
    },
    // 删除按钮
    // deleteit(row) {
    //   this.answerTableData.splice(row.index, 1);
    // },
    /**
     * 添加答案
     */
    submitAnswer() {
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        const { data: resData } = await this.$post(
          "exam/answer/list",
          {
            answers: this.answerTableData,
            questionId: this.answerParams.questionId,
          },

          {
            headers: {
              isLoading: true,
            },
          }
        );
        if (resData.result != 200) return;
        this.$message.success("添加成功!");

        // this.getTopicList(this.resue.code); //RENEW table
        this.getWDList();
        this.getAppraisalData();

        // this.dialogVisibleAnswer = false;
      });
    },
    /**
     * 删除答案
     */
    handleAnswerDelete(row, index) {
      if (!row.examAnswerId) {
        this.answerTableData.splice(index, 1);
      } else {
        this.$confirm("此操作将删除答案数据, 是否继续?", "提示", {
          type: "warning",
        }).then(async () => {
          const { data: resData } = await this.$delete(
            `exam/answer/info/${row.answerId}`,
            {
              headers: {
                isLoading: true,
              },
            }
          );
          if (resData.result != 200) return;

          this.getTopicList();

          this.$message.success("删除成功!");
        });
      }
    },
    /**
     * 跳转结果设置
     */
    handelResultSet() {
      this.$router.push({
        name: "WDPJ_SET",
        query: {
          examId: this.$route.query.examId,
        },
      });
    },
  },
};
</script>